<template>
  <div class="app-list-root">
    <el-row style="margin-bottom: 20px">
      <el-col :span="12">
        <router-link :to="{
          name: 'Apps',
          query: { action: 'new', project: currentProjectId },
        }">
          <el-button type="primary" size="large">
            <span>+ 创建新应用</span>
          </el-button>
        </router-link>

        <router-link :to="{
          name: 'Apps',
          params: {
            filterTerm: filterTerm,
            curTabLabel: curTabLabel,
            dragShow: dragShow,
          },
          query: { action: 'search', project: currentProjectId },
        }" style="margin-left: 12px">
          <el-button type="primary" size="large">
            <i class="iconfont icon-sousuo"></i>
            按安装包信息搜索
          </el-button>
        </router-link>

        <el-input clearable v-model="filterTerm" placeholder="请输入应用名称进行筛选"
          style="width: 240px; text-transform: uppercase; margin-left: 12px" size="large">
          <template #suffix>
            <i class="iconfont icon-sousuo"></i>
          </template>
        </el-input>
      </el-col>

      <el-col :span="12" style="text-align: right">
        <el-button v-if="isAdmin" v-show="dragShow" type="primary" size="large" @click="handleSaveOrder">保存排序
        </el-button>
        <el-button v-if="isAdmin" v-show="dragShow" type="primary" size="large" @click="handleResetOrder">
          还原排序
        </el-button>
      </el-col>
    </el-row>

    <TakoPanel :header="false" style="padding: 10px 20px" v-loading="loadingApps">
      <AppsTabs :curTabLabel="curTabLabel" :isAdmin="isAdmin" :tableData="projectApps" :tableKey="appsKey"
        :filterTerm="filterTerm" @dragDataListTable="handleDragDataListTable" @dragShowChange="handleDragShowChange"
        @platformChange="handlePlatformChange" @curTabLabelChange="handleCurTabLabelChange" />
    </TakoPanel>
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted, ref } from "vue";
import { useProjectStore } from "@/Store/ProjectStore";
import { storeToRefs } from "pinia";
import TakoPanel from "@/Components/TakoPanel.vue";
import AppsTabs from "@/Components/AppsTabs.vue";
import { useRoute } from "vue-router";
import { apiSortPriority, apiSortReduction } from "@/Api/AppApi";
import { ElMessageBox } from "element-plus";

const { appContext } = getCurrentInstance();
const $message = appContext.config.globalProperties.$message;

const route = useRoute();
const projectStore = useProjectStore();

const { isAdmin, projectApps, currentProjectId, loadingApps } =
  storeToRefs(projectStore);

const filterTerm = ref("");

const dragShow = ref(false);
function handleDragShowChange(val) {
  dragShow.value = val;
}

const curTabLabel = ref("all");
function handleCurTabLabelChange(val) {
  curTabLabel.value = val;
}

onMounted(() => {
  const params = route.params;
  if (params.filterTerm != undefined) {
    filterTerm.value = params.filterTerm.toString();
  }
  if (params.curTabLabel != undefined) {
    curTabLabel.value = params.curTabLabel.toString();
    dragShow.value = !!params.dragShow;
  }
});

let pid = null;
function handlePlatformChange(_, val) {
  pid = val;
}
let dragDataList = null;
function handleDragDataListTable(data) {
  dragDataList = data;
}
async function handleSaveOrder() {
  if (dragDataList == null) {
    $message.warning("没任何修改！");
    return;
  }
  const priority = [];
  const maxLen =
    dragDataList.length % 2 === 0
      ? dragDataList.length
      : dragDataList.length + 1;
  for (let i = 0; i < dragDataList.length; i++) {
    priority.push({ id: dragDataList[i].id, priority: maxLen - i });
  }
  const reqData = { priorities: priority };
  const res = await apiSortPriority(currentProjectId.value, reqData);
  if (res.code === 0) {
    dragDataList = null;
    $message.success("保存成功！");
    projectStore.getProjectApps();
  } else {
    $message.error(`保存失败：${res.message}`);
  }
}
async function handleResetOrder() {
  try {
    await ElMessageBox.confirm(
      "确定还原应用的修改时间默认排序吗, 是否继续?",
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    );

    const res = await apiSortReduction(currentProjectId.value, pid);
    if (res.code === 0) {
      $message.success("还原成功！");
      projectStore.getProjectApps();
    } else {
      $message.error(`还原失败：${res.message}`);
    }
  } catch (e) {
    // nothing
  }
}

const appsKey = [
  { name: "应用名称", prop: "appname" },
  { name: "所属平台", prop: "platform" },
  // {"name": "应用日志", "prop": "releaseversion.releasenote"},
  { name: "创建时间", prop: "createtime" },
  { name: "包更新时间", prop: "updatetime" },
  { name: "停用操作", prop: "disabled" },
  { name: "拖拽排序", prop: "drag" },
];
</script>

<style lang="scss" scoped>
.app-list-root {
  padding: 20px;
  height: 100%;
  overflow: auto;
}
</style>
